export default "__VITE_ASSET__Do__YezF__"